import { useState, useEffect } from 'react';
import { apiB2B, apiB2C } from '../api/axios-client';
import { isLoggedIn, isStoreFrontLoggedIn } from '../utils/user';
import { ERR_REDIRECT } from '../constants/response-error-messages';
export var useInterceptors = function () {
    var _a = useState(null), redirectError = _a[0], setRedirectError = _a[1];
    useEffect(function () {
        if (!isLoggedIn() && !isStoreFrontLoggedIn()) {
            redirectToSignIn();
        }
    }, []);
    var redirectToSignIn = function () {
        window.location.replace("/auth/view/signin?redirect=".concat(encodeURIComponent(window.location.pathname + window.location.search)));
        setRedirectError(ERR_REDIRECT);
    };
    var logonMiddleware = function (error) {
        var response = error.response;
        if (response &&
            (response.status === 401 ||
                response.status === 431 ||
                response.status === 404)) {
            redirectToSignIn();
        }
        return Promise.reject(error);
    };
    apiB2B.interceptors.response.use(undefined, logonMiddleware);
    apiB2C.interceptors.response.use(undefined, logonMiddleware);
    return {
        redirectError: redirectError,
    };
};
